import React from 'react';
import { Party, Warning, XMark } from 'src/components/icons';
import { useAppDispatch, useAppSelector } from 'src/store';
import class_user_status, {
  selectClassUserStatus,
} from 'src/store/model/class_user_status';
import { Modal } from 'src/components/custom';
import CourseExtensionForm from 'src/components/coreUI/CourseExtensionForm';
import { useSearchParams } from 'react-router-dom';

export type Props = {
  className?: string;
  style?: React.CSSProperties;
  class_id?: string;
  onClose?: () => void;
};

const backgroundColor = {
  EXPIRED: '#FAC3BE',
  NEARLY_EXPIRED: '#E5D9F1',
  COMPLETED: '#5FE7A3',
};

const textColor = {
  EXPIRED: '#DF3C2B',
  NEARLY_EXPIRED: '#5B3A89',
  COMPLETED: '#156D28',
};

const icon = {
  COMPLETED: <Party />,
  EXPIRED: <Warning color="#DF3C2B" />,
  NEARLY_EXPIRED: <Warning />,
};

const CourseNotificationMessage: React.FC<Props> = ({
  style = {},
  class_id,
  onClose,
}) => {
  const dispatch = useAppDispatch();
  let statusList = useAppSelector((state) => selectClassUserStatus(state));
  if (class_id) {
    statusList = statusList.filter((status) => status.class_id === class_id);
    statusList.sort((a, b) => {
      if (a.expired_at && b.expired_at) {
        return (
          new Date(b.expired_at).getTime() - new Date(a.expired_at).getTime()
        );
      }
      return 0;
    });
    if (statusList.length > 0) {
      statusList = statusList.slice(0, 1);
    }
  }

  const closed = useAppSelector(
    (state) => state.model.class_user_status.closed,
  );

  const closeBanner = () => {
    if (onClose) {
      onClose();
    } else {
      dispatch(class_user_status.updateHasClose(true));
    }
  };

  const [searchParams] = useSearchParams();

  const [open, setOpen] = React.useState(
    searchParams.get('showExtend') === 'true',
  );

  return (
    <React.Fragment>
      {statusList.map((classUserStatus) => {
        const { id: class_user_id, status, class: course } = classUserStatus;

        return (!closed || onClose) && status && status !== 'ACTIVE' ? (
          <div
            key={class_user_id}
            className="d-flex"
            style={{
              backgroundColor: backgroundColor[status || ''],
              borderRadius: 3,
              ...style,
            }}
          >
            <div className="d-flex-center gap-8 fs-16 py-16 flex-wrap flex-1">
              {icon[status || '']}
              <div
                className="fw-bold text-center"
                style={{
                  color: textColor[status || ''],
                }}
              >
                {status === 'EXPIRED' &&
                  `Your access to ${course.name} has already expired.`}
                {status === 'NEARLY_EXPIRED' &&
                  `Less than 14 days to complete the ${course.name} course!`}
                {status === 'COMPLETED' &&
                  `You’ve completed the ${course.name}!`}
              </div>
              <div className="text-center">
                {status === 'EXPIRED' && 'Request for an extension '}
                {status === 'NEARLY_EXPIRED' && 'Request for an extension '}
                {status === 'COMPLETED' &&
                  'Want to extend the course? Request '}
                <span
                  style={{ color: textColor[status || ''] }}
                  className="fw-bold cursor-pointer"
                  onClick={() => setOpen(true)}
                >
                  here
                </span>
              </div>
            </div>

            <div className="p-4 cursor-pointer" onClick={() => closeBanner()}>
              <XMark width={16} height={16} color={textColor[status]} />
            </div>

            <Modal
              visible={open}
              size="tiny"
              onClose={() => setOpen(false)}
              content={() => <CourseExtensionForm {...classUserStatus} />}
            />
          </div>
        ) : null;
      })}
    </React.Fragment>
  );
};

export default CourseNotificationMessage;
